import React from 'react'
import { Image } from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import Button from 'components/atoms/Button'
import BaseTemplate from 'components/templates/BaseTemplate'
import Container from 'components/atoms/Container'

const PaperplaneResultWaiting = () => (
  <BaseTemplate useNewHeader>
    <Container className="text-center p-y-lg">
      <Image
        src="/assets/img/peluang/thank-you-page-pop-up-banner.png"
        className="m-t-lg"
        style={{
        maxWidth: '100%',
      }}
      />

      <h3 className="m-y-md">
        <b style={{
          color: '#1A344F',
          fontSize: '24px',
        }}
        >
            Terima kasih! Kami akan segera menghitung hasil Cek Peluangmu.
        </b>
      </h3>
      <br/>

      <Typography variant="body" className="m-b-lg" style={{ color: '#1A344F' }}>
        Hasil Cek Peluang akan tersedia secara serentak di tanggal 24 Maret 2021. Kamu bisa mengaksesnya melalui Beranda Quipper.
      </Typography>
      <br/>

      <Button component="a" href="/" className="m-y-lg">
        <b style={{
          height: '34px',
          padding: '7px',
        }}
        >
            Kembali ke Beranda Quipper
        </b>
      </Button>
    </Container>
  </BaseTemplate>
  )

export default PaperplaneResultWaiting
